var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import { Button } from 'reactstrap';
import { currency } from '../../config';
import Trash from '../../icons/Trash';
import './cart-item.scss';
var renderAdditionalField = function (fieldText) {
    var _a = __read(fieldText.split(':')), fieldName = _a[0], fieldSelected = _a.slice(1);
    return (React.createElement("div", { key: fieldText },
        React.createElement("span", { className: "text-muted" },
            fieldName,
            fieldText.includes(':') ? ':' : '',
            ' '),
        React.createElement("span", { className: "cart-item__additional-field-value" }, fieldSelected.join(' ,'))));
};
var CartItem = function (_a) {
    var item = _a.item, onRemoveClick = _a.onRemoveClick;
    var price = item.displayPrice || item.price * item.amount;
    var fixedDecimalPrice = price.toFixed(2);
    var discountClass = item.hasDiscount
        ? 'cart-item__price--with-discount'
        : '';
    return (React.createElement("div", { className: "cart-item" },
        React.createElement("span", { className: "cart-item__amount" }, "".concat(item.amount, " x"),
            "\u00A0"),
        React.createElement("div", { className: "flex-fill" },
            React.createElement("span", { className: "cart-item__name" },
                item.name,
                " "),
            item.option && (React.createElement("span", { className: "cart-item__option" },
                "(",
                item.option,
                ")")),
            item.category && (React.createElement("div", { className: "cart-item__category" },
                "(",
                item.category,
                ")")),
            item.selectedAdditionalFields &&
                item.selectedAdditionalFields.map(renderAdditionalField),
            item.notes ? React.createElement("div", { className: "text-muted" }, item.notes) : null,
            React.createElement("div", { className: "d-flex justify-content-between" },
                React.createElement("div", { className: "cart-item__price-wrapper" },
                    React.createElement("div", { className: "cart-item__price ".concat(discountClass) },
                        fixedDecimalPrice,
                        " ",
                        currency),
                    item.oldPrice && (React.createElement("div", { className: "cart-item__price cart-item__price--old" },
                        item.oldPrice,
                        " ",
                        currency))),
                onRemoveClick && (React.createElement(Button, { color: "link", className: "p-0 align-self-end", onClick: onRemoveClick },
                    React.createElement(Trash, null)))))));
};
export default CartItem;
